import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { filterXSS } from 'xss';
import { MultipleLineTruncate } from '../../../../../components/LineTruncate';
import StringUtils from '../../../../../components/utils/StringUtils';
import css from './TruncateTextWithButton.module.scss';

interface OwnProps {
  className?: string;
  text: string;
  maxLine: number;
  noBottomMargin?: boolean;
}

type Props = OwnProps;

const TruncateTextWithButton = ({
  className,
  text,
  maxLine,
  noBottomMargin = false,
}: Props) => {
  const intl = useIntl();
  const [ellipsis, setEllipsis] = React.useState(true);
  const [clampedState, setClampedState] = React.useState(true);

  const classes = classNames(
    css.TruncateTextWithButton,
    className,
    noBottomMargin ? css.NoBottomMargin : '',
  );

  return (
    <div className={classes}>
      {ellipsis ? (
        <MultipleLineTruncate
          className={css.TruncateTextWithButton__Text}
          maxLine={maxLine}
          onReflow={({ clamped }) => setClampedState(!!clamped)}
          text={text}
        />
      ) : (
        <div
          className={css.TruncateTextWithButton__Text}
          dangerouslySetInnerHTML={{
            __html: StringUtils.nl2brString(filterXSS(text)),
          }}
        />
      )}
      {clampedState && (
        <button
          className={css.TruncateTextWithButton__Button}
          onClick={(ev) => {
            ev.preventDefault();
            setEllipsis(!ellipsis);
          }}
        >
          {ellipsis
            ? intl.formatMessage({
                id: 'merchants.truncateTextWithButton.truncateOpen',
              })
            : intl.formatMessage({
                id: 'merchants.truncateTextWithButton.truncateClose',
              })}
        </button>
      )}
    </div>
  );
};

export default TruncateTextWithButton;
